import { DsyContentSwitcher } from "./dsy-content-switcher";

import { findIndex } from "lodash";
export const MigrationContentSwitcher = ({
    entries,
    onClick,
    preselectedContentKey,
  }) => (
    <DsyContentSwitcher
      functionSetterData={(entry) => onClick?.(entry)}
      contentList={entries.map((entry, index) => ({
        id: `el-${index}`,
        title: entry?.label,
        data: entry,
      }))}
      indexContentChosed={findIndex(entries, (entry) => entry?.key === preselectedContentKey) ?? 0}
    />
  );